import { Link } from "@mantine/tiptap";
import { useEditor } from "@tiptap/react";
import { useEffect } from "react";
import StarterKit from "@tiptap/starter-kit";
import Placeholder from "@tiptap/extension-placeholder";
import { Color } from "@tiptap/extension-color";
import TextAlign from "@tiptap/extension-text-align";
import Superscript from "@tiptap/extension-superscript";
import SubScript from "@tiptap/extension-subscript";
export function useTeamsMessageEditor(disabled = false) {
	const editor = useEditor({
		shouldRerenderOnTransaction: true,
		extensions: [
			StarterKit,
			Link,
			Placeholder.configure({
				placeholder: "Enter your message",
			}),
			Color,
			TextAlign,
			Superscript,
			SubScript,
		],
		content: "",
	});
	useEffect(() => {
		editor?.setEditable(!disabled);
	}, [editor, disabled]);
	return editor;
}
